var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.667 1H1.833A.833.833 0 001 1.833v5.834c0 .46.373.833.833.833h5.834c.46 0 .833-.373.833-.833V1.833A.833.833 0 007.667 1zM7.667 12H1.833a.833.833 0 00-.833.833v5.834c0 .46.373.833.833.833h5.834c.46 0 .833-.373.833-.833v-5.834A.833.833 0 007.667 12zM18.667 12h-5.834a.833.833 0 00-.833.833v5.834c0 .46.373.833.833.833h5.834c.46 0 .833-.373.833-.833v-5.834a.833.833 0 00-.833-.833zM18.667 1h-5.834a.833.833 0 00-.833.833v5.834c0 .46.373.833.833.833h5.834c.46 0 .833-.373.833-.833V1.833A.833.833 0 0018.667 1z",
    fill: "#fff",
    stroke: "#000064",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgIconGrid;